import { OkOIcon, BlockIcon } from 'taboola-ultimate-ui';
import TargetingTypes from '../../../config/TargetingTypes';
import { AudienceDetailsWithBundling } from '../../AudienceDetailsWithBundling/AudienceDetailsWithBundling';
import styles from '../../MarketplaceAudiences/SegmentListItemContent/segmentListItemContent.module.scss';
import commonStyles from '../../commonAudienceListItemContent.module.scss';

export const SegmentListItemDetailsWithTargetingType = ({
    targetingType,
    searchText,
    labelTooltip,
    formattedSize,
    item,
    showSizes,
    shouldHideProvider,
}) => {
    const { label, provider, isTargetable, isBundle: isBundleType, taxonomyLabel } = item;
    const isStandalone = !isBundleType && isTargetable;

    return (
        <>
            <div>
                {targetingType === TargetingTypes.INCLUDE ? (
                    <OkOIcon className={commonStyles['include']} />
                ) : (
                    <BlockIcon className={commonStyles['exclude']} />
                )}
            </div>
            <AudienceDetailsWithBundling
                className={styles['audience-details']}
                label={label}
                highlightText={searchText}
                labelTooltip={labelTooltip}
                showSizes={showSizes}
                formattedSize={formattedSize}
                provider={isStandalone && provider}
                taxonomyLabel={taxonomyLabel}
                shouldHideProvider={shouldHideProvider}
            />
        </>
    );
};
